import script from "./tabelaKoparek_filtry.vue?vue&type=script&setup=true&lang=ts"
export * from "./tabelaKoparek_filtry.vue?vue&type=script&setup=true&lang=ts"

import "./tabelaKoparek_filtry.vue?vue&type=style&index=0&id=0a0d3142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a0d3142"]])

export default __exports__